// PitTile is a map tile that shows a pit that robots can fall into.

import { PitTileOrientation, PitTileType } from 'app/src/engine/tiles/PitTile';
import * as React from 'react';

function getClassNameForType(type: PitTileType): string {
	switch (type) {
		case PitTileType.Type1_1of1:
			return 'PitTile-pit--type1-1of1';
	}

	return '';
}

function getClassNameForOrientation(orientation: PitTileOrientation): string {
	switch (orientation) {
		case PitTileOrientation.Up:
			return 'PitTile-pit--up';
		case PitTileOrientation.Down:
			return 'PitTile-pit--down';
		case PitTileOrientation.Left:
			return 'PitTile-pit--left';
		case PitTileOrientation.Right:
			return 'PitTile-pit--right';
	}
}

type Props = {
	type: PitTileType;
	orientation: PitTileOrientation;
};

export default function PitTile({ type, orientation }: Props): React.ReactElement | null {
	const pitClassNames = [
		'PitTile-pit',
		getClassNameForType(type),
		getClassNameForOrientation(orientation),
	];
	return (
		<div className="PitTile">
			<div className={pitClassNames.join(' ')}></div>
		</div>
	);
}
